<template>
  <div>
    <p>
      <strong>{{ value }}</strong>
    </p>
    <div class="flex">
      <img v-if="isImageFile(value)" :src="preview" class="min-w-[180px] max-h-[150px] w-[200px]" />
      <i v-if="!isImageFile(value)" class="el-icon-document text-[40px] py-5 px-[50px]" />

      <!-- errors -->
      <template>
        <ul class="list-none p-0 mx-[10px] my-0">
          <template v-if="fileNotValidForScan">
            <li class="text-xs mb-[5px] mt-0 mx-0 text-left">
              <div class="flex items-center">
                <i class="el-icon-warning-outline mr-[5px]"></i>
                File is not valid for scan.
              </div>
            </li>
          </template>
          <template v-else-if="isBusy">
            <li class="text-xs mb-[5px] mt-0 mx-0 text-left">
              <div class="flex items-center">
                <i class="el-icon-loading mr-[5px]"></i>
                Pending: Scanning for virus...
              </div>
            </li>
          </template>
          <template v-else-if="isFileContainVirus">
            <li class="text-xs text-red-500 mb-[5px] mt-0 mx-0 text-left">
              <div class="flex items-center">
                <i class="el-icon-warning-outline mr-[5px]"></i>
                Invalid: File contain suspicious malware, please try with other file.
              </div>
            </li>
          </template>
          <template v-else-if="isValid">
            <li class="text-xs mb-[5px] mt-0 mx-0 text-left text-[#62c23a]">
              <div class="flex items-center">
                <i class="el-icon-circle-check mr-[5px]"></i>
                <span class="break-words">
                  Success: Please press confirm to continue uploading the file.
                </span>
              </div>
            </li>
          </template>

          <li
            class="text-xs text-red-500 mb-[5px] mt-0 mx-0 text-left break-words"
            v-for="(err, errIndex) in fileUploadErrors"
            :key="`file-upload-error-${errIndex}`"
          >
            <div class="flex items-center">
              <i class="el-icon-warning-outline mr-[5px]"></i>
              {{ err }}
            </div>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import { validateFile } from "@/helpers/validateFile";
import axios from "@/helpers/axios";
import _ from "lodash-es";

export default {
  name: "UploaderFile",
  props: ["value", "preview", "file"],
  data() {
    return {
      isBusy: false,
      isFileContainVirus: false,
      fileNotValidForScan: false,
      fileUploadErrors: [],
      fileIsValidForUpload: false,
    };
  },
  methods: {
    isImageFile(url) {
      const imageRegex = new RegExp("(jpg|jpeg)|(png)", "g");
      return imageRegex.test(url);
    },
    scanVirus() {
      if (!this.isBusy) {
        this.isBusy = true;
        this.$emit("update-is-busy", true);
        this.isFileContainVirus = false;
        const formData = new FormData();
        formData.append("file", this.file);
        axios
          .post(`${this.$store.state.server}/api/webchat_virus_scan`, formData)
          .then((response) => {
            const result = _.get(response, "data", {});
            const isSafe = !result.is_infected;
            const noVirusDetected = _.isEmpty(result.viruses);
            if (isSafe && noVirusDetected) {
              this.isFileContainVirus = false;
              this.$emit("update-antivirus-failed", false);
            }
          })
          .catch((err) => {
            console.error(err.message);
            this.isFileContainVirus = false;
            this.$emit("update-antivirus-failed", true);
          })
          .finally(() => {
            this.$emit("update-is-busy", false);
            this.isBusy = false;
          });
      }
    },
  },
  computed: {
    /**
     * @description All webchat config
     * @return {any}
     */
    settings() {
      return this.$store.getters.settings;
    },

    isValid() {
      const isValid = this.fileIsValidForUpload;
      return isValid;
    },
  },

  created() {
    validateFile(this.file).then(({ isValid, errors }) => {
      this.fileIsValidForUpload = isValid;
      this.fileUploadErrors = !isValid ? errors : [];
    });
  },

  mounted() {
    validateFile(this.file).then(({ isValid, errors }) => {
      this.$emit("update-is-file-type-invalid", !isValid);
      const fileNotValidForScan = !isValid;
      if (fileNotValidForScan) {
        this.fileNotValidForScan = true;
        return;
      }
      this.scanVirus();
    });
  },
};
</script>
